export enum AutoActivityPropertyKeys {
    Id = "Id",
    Name = "Name",
    NameLanguage = "NameLanguage",
    ClrTypeID = "ClrTypeID",
    Tools = 'Tools',
    variableSettings = 'variableSettings',
    ParticipantOptions = 'ParticipantOptions'
}
